<template>
  <div>
    <div class="w1180 mt10">
      <h4 class="modtit1 clearfix"><span>{{name}}</span><a
          class="more fr"
          :href="moreurl"
        >更多 &gt;</a></h4>
    </div>
    <div
      class="w1180 clearfix"
      :id="lesstype=='ggk'?'gkclass':'jsclass'"
    >
      <div class="modconl fl">
        <!--20180102 改为碎片维护
            <div class="fvcon fl mr18 mb20" :style="lesstype=='ggk'?'display:none':''">
                <div class="fvconl fl">
                    <div class="fvtit"><a :href="'//caidao.homeway.com.cn/'+tjlesson.teacherId+'/lesson'+tjlesson.classId+'.html'">{{tjlesson.className}}</a><span :style="tjlesson.onlineStatus=='1'?'':'display:none'" class="sty1 fr">直播中</span></div>
                    <div class="flashdiv mt10">
                        <a :href="'//caidao.homeway.com.cn/'+tjlesson.teacherId+'/lesson'+tjlesson.classId+'.html'"><img :src="tjlesson.classImage" :alt="tjlesson.className"></a>
                    </div>
                    <dl class="flashx mt10 clearfix">
                        <dt><div class="fl xing"><div class="x" :style="tjlesson.liner"></div><img src="./../assets/web/images/toubing.png"></div><span class="c-999 f12">{{tjlesson.commentGoodRate}}%</span></dt>
                        <dd>{{tjlesson.onlineViewNum}}观看</dd>
                    </dl>
                </div>
                <div class="fvconr fr">
                    <p class="mt20"><a :href="'//caidao.homeway.com.cn/'+tjlesson.teacherId+'/index.html'"><img :src="tjlesson.teacherImage" alt=""></a></p>
                    <p class="mt10"><a :href="'//caidao.homeway.com.cn/'+tjlesson.teacherId+'/index.html'">{{tjlesson.teacherName}}</a></p>
                    <p class="f12 c-999">{{tjlesson.classIntro}}</p>
                    <a href="//caidao.homeway.com.cn/lesson/list.html" class="moreclass mt20">更多课程</a>
                </div>
            </div>
            <div :key='item' :style="lesstype=='ggk'?'display:none':''" :class="(lesstype=='tsk'&&(index==2||index==7))?'classbox fl mb20':'classbox mr18 fl mb20'" v-for="(item,index) in lesson" v-on:click="golink(item.teacherId,item.classId)">
            <span :style="item.onlineStatus=='1'?'':'display:none'" class="i-zb">直播中</span>
            	<div class="classimg">
                    <p><img :src="lesstype=='ggk'?item.classImageUrl:item.classImage" :alt="item.className"></p>
                    <p class="alpbg"></p>
                </div>
                <div class="classInf">
                    <p class="txtinf">{{item.className}}</p>
                    <p class="f12 c-999 mt10">{{item.teacherName}}</p>
                    <dl class="flashx mt10 clearfix">
                        <dt><div class="fl xing"><div class="x" :style="item.liner"></div><img src="./../assets/web/images/toubing.png"></div><span class="c-999 f12 fr">{{item.commentGoodRate}}%</span></dt>
                        <dd>{{item.countComment}}条评论</dd>
                    </dl>
                </div>
            </div>
        -->
      </div>
      <div
        id="lessonclude"
        :style="lesstype=='ggk'?'':'display:none'"
      >
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ['lesstype'],
  name: 'lesson',
  data() {
    return {
      lesson: [],
      tjlesson: [],
      name: '',
      moreurl:
        '//' +
        (window.location.host.match('test') ? 'test' : '') +
        'caidao.homeway.com.cn/lesson/list.html'
    };
  },
  methods: {
    bindlesson: function () {
      var _this = this,
        tjurl = _this.apilist.banner,
        url = _this.apilist.banner;
      if (_this.lesstype == 'ggk') {
        _this.moreurl += '?typeid=1';
        // $("#lessonclude").html($("#lclude").html());
        this.getData(this.apilist.incData + '7850_190691206', function (_res) {
          if (_res.code * 1 === 0 && _res.data) {
            $('#lessonclude').html(_res.data);
          }
        });

        // $("#gkclass .modconl").html($("#ggklist").html());
        this.getData(this.apilist.incData + '7850_191327420', function (_res) {
          if (_res.code * 1 === 0 && _res.data) {
            $('#gkclass .modconl').html(_res.data);
          }
        });
        _this.name = '公开课';
      } else {
        // $("#jsclass .modconl").html($("#tsklist").html());
        this.getData(this.apilist.incData + '7850_192058322', function (_res) {
          if (_res.code * 1 === 0 && _res.data) {
            $('#jsclass .modconl').html(_res.data);
          }
        });
        _this.name = '特色课程';
        tjurl = tjurl + '9/1/1';
        url = url + '12/1/8';
      }
      console.log('20180105');
      $('.classbox')
        .removeClass('on')
        .hover(
          function () {
            $(this).addClass('on');
          },
          function () {
            $(this).removeClass('on');
          }
        );
      /*if (_this.lesstype != "ggk") {
        _this.getData(tjurl, function(data) {
          if (data.code == "0") {
            for (var i in data.data.list) {
              data.data.list[i].onlineViewNum =
                data.data.list[i].onlineViewNum == null
                  ? 0
                  : data.data.list[i].onlineViewNum;
              data.data.list[i].countComment =
                data.data.list[i].countComment == null
                  ? 0
                  : data.data.list[i].countComment;
              data.data.list[i].className =
                data.data.list[i].className.length > 14
                  ? data.data.list[i].className.substring(0, 14)
                  : data.data.list[i].className;
              data.data.list[i].classIntro =
                data.data.list[i].classIntro.length > 20
                  ? data.data.list[i].classIntro.substring(0, 20) + "..."
                  : data.data.list[i].classIntro;
              data.data.list[i].classImage =
                data.data.list[i].classImage == null ||
                data.data.list[i].classImage == ""
                  ? "//imgcd.homeway.com.cn/images/default.jpg"
                  : data.data.list[i].classImage;
              data.data.list[i].commentGoodRate =
                data.data.list[i].commentGoodRate == null
                  ? 0
                  : data.data.list[i].commentGoodRate * 100;
              data.data.list[i].liner =
                "width:" + data.data.list[i].commentGoodRate + "%";
              _this.tjlesson = data.data.list[i];
            }
          }
        });
        _this.getData(url, function(data) {
          if (data.code == "0") {
            for (var i in data.data.list) {
              if (_this.lesstype == "ggk" && i > 5) break;
              data.data.list[i].classImage =
                data.data.list[i].classImage == null ||
                data.data.list[i].classImage == ""
                  ? "//imgcd.homeway.com.cn/images/default.jpg"
                  : data.data.list[i].classImage;
              if (_this.lesstype == "ggk") {
                data.data.list[i].classImage =
                  data.data.list[i].classImageUrl == null ||
                  data.data.list[i].classImageUrl == ""
                    ? "//imgcd.homeway.com.cn/images/default.jpg"
                    : data.data.list[i].classImageUrl;
              }
              data.data.list[i].countComment =
                data.data.list[i].countComment == null
                  ? 0
                  : data.data.list[i].countComment;
              data.data.list[i].countComment =
                data.data.list[i].countComment > 10000
                  ? parseInt(data.data.list[i].countComment / 10000) + "万"
                  : data.data.list[i].countComment;
              data.data.list[i].commentGoodRate =
                data.data.list[i].commentGoodRate == null
                  ? 0
                  : data.data.list[i].commentGoodRate * 100;
              data.data.list[i].liner =
                "width:" + data.data.list[i].commentGoodRate + "%";
              _this.lesson.push(data.data.list[i]);
            }
            _this.$nextTick(function() {
              $(".modconl .classbox,#jsclass .classbox").hover(function() {
                $(this)
                  .siblings()
                  .removeClass("on");
                $(this).addClass("on");
              });
            });
          }
        });
      }*/
    },
    golink: function (teacherId, classId) {
      window.open(
        '//' +
          (window.location.host.match('test') ? 'test' : '') +
          'caidao.homeway.com.cn/' +
          teacherId +
          '/lesson' +
          classId +
          '.html'
      );
    }
  },
  mounted() {
    this.bindlesson();
  }
};
</script>



// WEBPACK FOOTER //
// lesson.vue?84e56cfa